import { render } from "./Home.vue?vue&type=template&id=83fb8806&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=83fb8806&lang=less&scoped=true"

import exportComponent from "E:\\交接项目\\基立福\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fb8806"]])

export default __exports__